import { ApiLinkEntity, ApiLinkRel, FileType } from "config/constants"
import { IApiLink, IMultipleEntitiesResponse } from "@/types"
import AssetImportItem, { IGetAssetImportItemDto } from "./AssetImportItem"

export const ASSET_IMPORT_TEMPLATE_URL = "/files/Asset-Import.xlsx"
export const ASSET_IMPORT_MAX_SIZE_MB = 5
export const ASSET_IMPORT_EXTENSIONS = [".xlsx"]
export const ASSET_IMPORT_TYPES = [FileType.msOffice]
export const ASSET_IMPORT_INPUT_FILE_ACCEPT = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]
export const ASSET_IMPORT_ROWS_LIMIT = 300

export enum AssetImportOperationStatus {
    idle = "idle",
    validation = "validation",
    invalid = "invalid",
    importing = "importing",
}

export enum AssetImportError {
    contentType = "ContentType",
    size = "Size",
    rowsLimit = "RowsLimit",
    template = "Template",
}

export interface IGetAssetImportOperationDto extends IMultipleEntitiesResponse<IGetAssetImportItemDto> {
    status: AssetImportOperationStatus
}

export default class AssetImportOperation {
    items: AssetImportItem[]
    status: AssetImportOperationStatus
    linkAssetImportFileUpload?: IApiLink
    linkAssetImportOperationClose?: IApiLink
    linkDeleteAssetImportItems?: IApiLink
    linkImportAssetImportItems?: IApiLink

    constructor(dto: IGetAssetImportOperationDto) {
        this.items = dto.entities.map((item, idx) => new AssetImportItem(item, idx + 1))
        this.status = dto.status

        this.linkAssetImportFileUpload = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.assetImport && lnk.rel === ApiLinkRel.new)
        this.linkAssetImportOperationClose = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.assetImport && lnk.rel === ApiLinkRel.delete)
        this.linkDeleteAssetImportItems = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.assetImportItem && lnk.rel === ApiLinkRel.delete)
        this.linkImportAssetImportItems = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.assetImportItem && lnk.rel === ApiLinkRel.create)
    }
}
